"use client"

import type React from "react"
import { useState } from "react"
import { ChevronDown, ChevronUp } from "lucide-react"

export const DataSourceInfo: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="mt-8 border-t border-gray-200 pt-4">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="flex items-center justify-between w-full text-left text-sm text-blue-600 hover:underline focus:outline-none bg-transparent"
      >
        <span>Datakällor och metodik</span>
        {isExpanded ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      {isExpanded && (
        <div className="mt-2 text-sm text-gray-600 space-y-2">
          <p>
            All data som presenteras på den här sidan kommer från Skolverkets officiella statistik om inte annat specificeras.
          </p>
          <p>
            Vi strävar efter att redovisa den senast tillgängliga informationen. I dagsläget redovisas data på skolor från läsåret 2023/2024, med undantag av meritvärde som är från 2024/2025 och data på elever och lärare som är från läsåret 2024/2025 - om inte annat anges, tex där vi redovisar 3 års historik.
            För antalet elever per lärare så är alla årskurser inräknade, dvs inklusive förskoleklass. Dock ingår ej fritidspersonal. 
          </p>
          <p>
            Värden som saknas anges som n/a eller att data saknas. Detta kan bero på att data inte existerar eller att dataunderlaget är för litet för att redovisas av Skolverket.
          </p>
          <p>
            Resultat från Skolenkäten är från åren 2024 och 2025. Notera att det variera mellan skolor om det är 2024 eller 2025, eftersom enkäten genomförs vartannat år för
            samtliga skolor. Datakällan för skolenkäten är Skolinspektionen.
          </p>
        </div>
      )}
    </div>
  )
}

